<template>
    <div v-if="loaded">
        <div
            v-if="subscription.plan && subscription.plan.id === 'complimentary'"
        >
            <div
                class="m-4 bg-primary-lighter py-4 px-8 rounded md:flex md:items-center md:justify-between"
            >
                <div class="py-2 px-4 rounded-md text-primary">
                    <p>
                        Congratulations! You're enjoying our complimentary
                        membership and will get access to all the current and
                        future features for <strong>free forever</strong>.
                    </p>
                </div>
            </div>
        </div>
        <div v-else-if="subscription.status === null">
            <team-plan-picker :endpoint="endpoint"></team-plan-picker>
        </div>
        <div v-else>
            <subscription-plan
                :status="subscription.status"
                :plan="subscription.plan"
                :endpoint="endpoint"
                picker="team-plan-picker"
                v-if="subscription.plan"
            >
            </subscription-plan>
            <subscription-payment-method
                :billing-portal-url="subscription.billing_portal_url"
                :card="subscription.card"
                :endpoint="endpoint"
                v-if="subscription.card"
            >
            </subscription-payment-method>
        </div>
        <subscription-payment-history
            :invoices="subscription.invoices"
            v-if="subscription.invoices && subscription.invoices.length > 0"
        >
        </subscription-payment-history>
    </div>
    <div v-else>
        <loading />
    </div>
</template>

<script>
export default {
    props: {
        team: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loaded: false,
            endpoint: `/api/teams/${this.team.id}/subscription`,
            subscription: {},
        };
    },
    mounted() {
        axios
            .get(`${this.endpoint}?full`)
            .then((response) => {
                this.subscription = response.data.data;
                this.loaded = true;
            })
            .catch((err) => {
                console.error(err);
            });
    },
};
</script>
